import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Redirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectUser = () => {
      const userAgent = navigator.userAgent.toLowerCase();

      // Android
      if (userAgent.includes('android')) {
        window.location.href = 'https://play.google.com/store/apps/details?id=it.sinelec.freeflow.a21';
        return;
      }

      // iOS
      if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
        window.location.href = 'https://apps.apple.com/us/app/freeflow-a21/id6756372676';
        return;
      }

      // Fallback per altri dispositivi
      window.location.href = 'https://a21ffpagaonline.astmservice.it/freeflow/';
    };

    redirectUser();
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <h2>Reindirizzamento in corso...</h2>
      <p>Se il reindirizzamento non avviene automaticamente, clicca uno dei link sottostanti:</p>
      <div style={{ display: 'flex', gap: '20px' }}>
        <a
          href="https://play.google.com/store/apps/details?id=it.sinelec.freeflow.a21"
          style={{ padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', textDecoration: 'none', borderRadius: '5px' }}
        >
          Android
        </a>
        <a
          href="https://apps.apple.com/us/app/freeflow-a21/id6756372676"
          style={{ padding: '10px 20px', backgroundColor: '#2196F3', color: 'white', textDecoration: 'none', borderRadius: '5px' }}
        >
          iOS
        </a>
        <a
          href="https://a21ffpagaonline.astmservice.it/freeflow/"
          style={{ padding: '10px 20px', backgroundColor: '#FF9800', color: 'white', textDecoration: 'none', borderRadius: '5px' }}
        >
          Web
        </a>
      </div>
    </div>
  );
};

export default Redirect;
